import { render, staticRenderFns } from "./ShipmentsTable.vue?vue&type=template&id=3515c8b2&scoped=true&"
import script from "./ShipmentsTable.vue?vue&type=script&lang=js&"
export * from "./ShipmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentsTable.vue?vue&type=style&index=0&id=3515c8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515c8b2",
  null
  
)

export default component.exports